import { Component, OnInit } from '@angular/core';
import { ResourceAccessService, ResourcePlanningAccess } from '../../../Services/resource-access.service';

interface ResourceSection {
  path: string;
  label: string;
  icon: string;
  hint: string;
  visible: (access: ResourcePlanningAccess) => boolean;
}

@Component({
  selector: 'app-resource-shell',
  templateUrl: './resource-shell.component.html',
  styleUrls: ['./resource-shell.component.css']
})
export class ResourceShellComponent implements OnInit {
  loading = true;
  error = '';
  access: ResourcePlanningAccess | null = null;

  /** Bereiche in fester Reihenfolge; sichtbar je nach Berechtigung (die API prüft selbst). */
  readonly sections: ResourceSection[] = [
    { path: 'mein-kalender', label: 'Mein Kalender', icon: 'event', hint: 'Meine Termine', visible: () => true },
    { path: 'planung', label: 'Teamplanung', icon: 'calendar_month', hint: 'Termine der Mitarbeiter', visible: a => a.canManagePlanning },
    { path: 'kapazitaet', label: 'Kapazität', icon: 'donut_large', hint: 'Auslastung und Engpässe', visible: a => a.canViewCapacity },
    { path: 'abwesenheiten', label: 'Abwesenheiten', icon: 'beach_access', hint: 'Urlaub und Anträge', visible: () => true },
    { path: 'verwaltung', label: 'Verwaltung', icon: 'admin_panel_settings', hint: 'Teams, Mitarbeiter, Skills & Kategorien', visible: a => a.canManageTeams || a.canManageSkills }
  ];

  constructor(private accessApi: ResourceAccessService) {}

  ngOnInit(): void {
    this.accessApi.getMine().subscribe({
      next: access => {
        this.access = access;
        this.loading = false;
      },
      error: () => { this.loading = false; this.error = 'Berechtigungen konnten nicht geladen werden.'; }
    });
  }

  get visibleSections(): ResourceSection[] {
    const access = this.access;
    return access ? this.sections.filter(s => s.visible(access)) : [];
  }

  get hasNoTeam(): boolean {
    return !!this.access && !this.access.isGlobalPlanner && this.access.teams.length === 0;
  }

  get canOpenMonitor(): boolean { return !!this.access?.isGlobalPlanner; }
}
